// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"CarInfoPlaceHolder_placeholder__GAfsq","fieldSet":"CarInfoPlaceHolder_fieldSet__1GPRC","cell":"CarInfoPlaceHolder_cell__3GgA5"};